import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";

import "../scss/Dashboard.css";
import { getCoupleDetails } from "../redux/marriageSlice";

const Header = () => {
  const dispatch = useDispatch();
  const [hasGuests, setHasGuests] = useState(false);

  useEffect(() => { 
    getCoupleDetail();
  }, [dispatch]);

  const getCoupleDetail = async () => {
    const response = await dispatch(getCoupleDetails());
    const totalGuests = response?.payload?.total_guests || 0;
    setHasGuests(totalGuests>0);
  };

  return (
    <nav className="navbar navbar-expand-lg top-menu top-menu-admin navbar-light">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          {" "}
          Menu
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="crl"></div>
        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ml-auto text-center icon-nav">
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/dashboard"} >
                <div className="link-text">Dashboard</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/myEvents"} >
                <div className="link-text">Events</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/contacts"} >
                <div className="link-text">Contacts</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/invitations"}  >
                <div className="link-text">Invitations</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/guest/questions"}  >
                <div className="link-text">Questions</div>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/guests/template"} >
                <div className="link-text">Design</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/wedding_website/edit"} >
                <div className="link-text">Wedding Website</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active"  className="nav-link" to={"/guest/reports"}>
                <div className="link-text"> Reports</div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/rsvp/review"}>
                <div className="link-text">RSVP</div>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/guest/gifts"}>
                <div className="link-text">Gift Received</div>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink activeClassName="nav-link active" className="nav-link" to={"/package/purchase"}>
                <div className="link-text">
                  {hasGuests ? <>Upgrade</> : <>Purchase</>}
                </div>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
